// extracted by mini-css-extract-plugin
export default {"card":"CommentCard_card__zSuhJ","header":"CommentCard_header__aIHZB","comment":"CommentCard_comment__MIJmy"};